module.exports = "pegasus_template/assets/graycircle-facebook.png";